import { render, staticRenderFns } from "./UserBlockButton.vue?vue&type=template&id=391653f9&"
import script from "./UserBlockButton.vue?vue&type=script&lang=js&"
export * from "./UserBlockButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports